export const dateKey = "Select date";
export const MIN_SELECTED_QUANTITY_FOR_MERCHANDISE = 2;
export const INITIAL_DATA_TYPE = {
  PLAN: "plan",
  LISTING: "listing",
};
